// src/pages/user/Dashboard.jsx
import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import {
  MdShoppingCart,
  MdBuild,
  MdCheckCircle,
  MdPending
} from 'react-icons/md';
import UserMasterLayout from '../../../layout/useradmin/UserMasterLayout';
import '../../../assets/css/useradmin/userdashboard/UserDashboard.css';
import AppContext from '../../../context/AppContext';
import axios from 'axios';

const UserDashboard = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken } = useContext(AppContext);

  // stat cards data
  const [stats, setStats] = useState({
    totalRentals: 0,
    totalMechanics: 0,
    activeRentals: 0,
    activeMechanics: 0,
  });

  // inprogress rentals list
  const [activeRentals, setActiveRentals] = useState([]);

  // inprogress mechanics list
  const [activeMechanics, setActiveMechanics] = useState([]);

  const getDashboardData = () => {
    axios.get(`${baseUrl}/user/dashboard`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.data)
      .then((data) => {
        setStats(data.stats);
        setActiveRentals(data.activeRentals);
        setActiveMechanics(data.activeMechanics);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  const statsData = [
    { icon: <MdShoppingCart />, value: stats.totalRentals, label: "Total Rentals", iconBg: '#FFF8E6', iconColor: '#FDB714' },
    { icon: <MdBuild />, value: stats.totalMechanics, label: "Total Mechanics", iconBg: '#FFF8E6', iconColor: '#FDB714' },
    { icon: <MdCheckCircle />, value: stats.activeRentals, label: "Active Rentals", iconBg: '#FFF8E6', iconColor: '#FDB714' },
    { icon: <MdPending />, value: stats.activeMechanics, label: "Active Mechanics", iconBg: '#FFF8E6', iconColor: '#FDB714' },
  ];

  return (
    <UserMasterLayout>
      <div className="ud-page">

        {/* Welcome Section */}
        <div className="ud-welcome-section">
          <h2>Welcome back! 👋</h2>
          <p>Here's what's happening with your rentals today</p>
        </div>

        {/* Stat Cards */}
        <div className="ud-stats-container">
          <Row className="g-4 mb-4">
            {statsData.map((stat, i) => (
              <Col key={i} xl={3} lg={3} md={6} sm={12}>
                <div className="ud-stat-card">
                  <div
                    className="ud-stat-icon"
                    style={{ backgroundColor: stat.iconBg, color: stat.iconColor }}
                  >
                    {stat.icon}
                  </div>
                  <div className="ud-stat-content">
                    <h3>{stat.value}</h3>
                    <p>{stat.label}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        {/* Main Content */}
        <Row>

          {/* Active Rentals */}
          <Col lg={6} md={12} className="mb-4">
            <div className="ud-section-card">
              <div className="ud-section-header">
                <h3>Active Rentals</h3>
              </div>

              <div className="ud-active-list">
                {activeRentals.length === 0 && <p>No active rentals</p>}

                {activeRentals.map((rental) => (
                  <div key={rental.id} className="ud-active-card">
                    <div className="ud-card-info">
                      <h4>{rental.location}</h4>
                      <div className="ud-card-details">
                        <span>📅 {rental.bookingdate}</span>
                        <span>💰 Rs {rental.totalprice}</span>
                      </div>
                    </div>
                    <div className="ud-card-status">
                      <span className="ud-days-badge">{rental.duration} days</span>
                     
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Col>

          {/* Active Mechanics */}
          <Col lg={6} md={12} className="mb-4">
            <div className="ud-section-card">
              <div className="ud-section-header">
                <h3>Active Mechanics</h3>
              </div>

              <div className="ud-active-list">
                {activeMechanics.length === 0 && <p>No active mechanics</p>}

                {activeMechanics.map((mechanic) => (
                  <div key={mechanic.id} className="ud-active-card">
                    <div className="ud-card-info">
                      <h4>{mechanic.fullname}</h4>
                      <div className="ud-card-details">
                        <span>🛠 {mechanic.machinerytype}</span>
                        <span>📍 {mechanic.location}</span>
                      </div>
                    </div>
                    <div className="ud-card-status">
                      <span className="ud-days-badge">{mechanic.status}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Col>

        </Row>
      </div>
    </UserMasterLayout>
  );
};

export default UserDashboard;